// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_165","cls2":"ProfileDropdown-cls2_DNi ProfileDropdown-cls1_165"};